module.exports = __webpack_public_path__ + "static/media/30.1ee1b98c.jpg";